import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser, selectAuthLoading, selectIsAuthenticated, selectIsSuperAdmin, selectIsCompanyAdmin } from '../../store/authSlice';

const ProtectedRoute = ({ children, requireSuperAdmin = false, requireCompanyAdmin = false }) => {
    const user = useSelector(selectUser);
    const loading = useSelector(selectAuthLoading);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const isSuperAdmin = useSelector(selectIsSuperAdmin);
    const isCompanyAdmin = useSelector(selectIsCompanyAdmin);
    const location = useLocation();

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh'
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireSuperAdmin && !isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    if (requireCompanyAdmin && !isCompanyAdmin && !isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
